import React, { useRef } from 'react';
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import LandingRouter from "./LandingRouter";
import NovedadesRouter from "./NovedadesRouter";
import DesarrollosRouter from "./DesarrollosRouter";
import SpaceportSimulator from '../components/SpaceportSimulator/SpaceportSimulator.js';
import Footer from "../components/Footer/Footer";
import ResponsiveNavbar from "../components/ResponsiveNavbar/ResponsiveNavbar";
import { RefProvider } from '../context/RefContext';
import { useLingui } from "@lingui/react";

const AppRouter = () => {
    const { i18n } = useLingui();
    const companyRef = useRef(null);
    const visionRef = useRef(null);
    const weRef = useRef(null);
    const contactRef = useRef(null);

    const handleScrollTo = (ref) => {
        if (ref && ref.current) {
            setTimeout(() => ref.current.scrollIntoView({ behavior: 'smooth' }), 1000);
        }
    };

    return (
        <RefProvider>
            <BrowserRouter>
                <Routes>
                    {/* 1. STANDALONE ROUTE: No Navbar or Footer here */}
                    <Route path="/desarrollos/rocha" element={<SpaceportSimulator />} />
                    <Route path="/desarrollos/rocha/:sceneId" element={<SpaceportSimulator />} />

                    {/* 2. THE WRAPPER: All children inside this element get the common UI */}
                    <Route
                        element={
                            <>
                                <ResponsiveNavbar
                                    refs={{
                                        companyRef,
                                        visionRef,
                                        weRef,
                                        contactRef,
                                    }}
                                    handleScrollTo={handleScrollTo} 
                                />
                                <Outlet /> {/* Your pages (Landing, etc.) will render here */}
                                <Footer />
                            </>
                        }
                    >
                        {/* These are the children that live inside the Frame above */}
                        <Route path='/' element={<LandingRouter />} />
                        <Route path='/novedades/*' element={<NovedadesRouter />} />
                        <Route path='/desarrollos/' element={<DesarrollosRouter />} />
                        <Route path='*' element={<LandingRouter />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </RefProvider>
    );
};

export default AppRouter;